import React from 'react';
import Categories from "../../components/Home/Category";
import Products from "../../components/Home/Product";
import Hero from "../../components/Home/Hero";
import PopularProducts from "../../components/Home/PopularProduct";
import Lastsection from "../../components/Home/LastSection";

const HomePage = () => {
  return (
    <main>
      <Hero />

      <section className="p-6 xxl:p-12 xl:p-12 lg:p-12 md:p-6 sm:p-6 xs:p-6 my-7">
        <Categories />
      </section>

      <section className="p-6 xxl:p-12 xl:p-12 lg:p-12 md:p-6 sm:p-6 xs:p-6 my-7">
        <Products />
      </section>

      <section>
        <PopularProducts />
      </section>

      <section className="pt-6 xxl:pt-12 xl:pt-12 lg:pt-12 md:pt-6 sm:pt-6 xs:pt-6">
        <Lastsection />
      </section>
    </main>
  );
};

export default HomePage;
